/**
 * @description 样式定义
 */

export const LAYOUT_DEFINE = {
  /**
   * @description 页面顶部header高度 rem
   */
  HEADER_HEIGHT: 16,
};
